export default "__VITE_ASSET__B_o2iEYC__"